export const ORDER_STATUS = {
  ERROR: 'error',
  DRAFT: 'draft',
  OPEN: 'open',
};
export const LOAD_FAILED_ORDERS_PARAMS = {
  STATUS: 'error',
  LIMIT: 200,
};

export const FAILED_ORDERS_RESEND_POLLING = {
  MAX_ATTEMPTS: 5,
  DELAY: 1000,
};

export const PHOTO_ID_EMAIL_STATUS_POLLING = {
  INTERVAL_MS: 1500,
  TIMEOUT_MS: 15000,
};

export const ORDER_STATUS_SYNC = {
  MAX_ATTEMPTS: Math.ceil((60 * 1000) / 5000), // 1 minute
  DELAY: 5000,
  CREATED_LIMIT_HOURS: Number(process.env.REACT_APP_ORDER_STATUS_SYNC_MAX_HOURS) || 24,
  ENV_CROPS_PROCESSING_HOURS: Number(process.env.REACT_APP_ENV_CROPS_PROCESSING_HOURS) || 2,
};

export const PUBLISH_STATUS = {
  PENDING: 'pending',
  ERROR: 'error',
  SENT: 'sent',
};

export const FAILED_ORDER_MINS_BETWEEN_RESENDS = Number(
  process.env.REACT_APP_FAILED_ORDER_MINS_BETWEEN_RESENDS,
);
